module.exports = __webpack_public_path__ + "static/media/michael metallo.dfc2cfb5.jpeg";